import { Component, Input, SimpleChanges, ViewChild } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { FormControl, FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Subject, debounceTime, switchMap } from 'rxjs';
import { ApiService } from '../services/api.service';

@Component({
  selector: 'app-firmwares',
  standalone: true,
  imports: [
    MatTableModule,
    MatSelectModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    FormsModule,
    MatGridListModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
  ],
  templateUrl: './firmwares.component.html',
  styleUrl: './firmwares.component.css',
})
export class FirmwaresComponent {
  @Input() tabSelected: boolean = false;
  loading = false;
  displayedColumnsForm = new FormControl('');

  displayedColumns: string[] = ['model', 'version', 'mode', 'actions'];
  filteredColumns: string[] = this.displayedColumns.filter(
    (col) => col !== 'actions'
  );
  dataSource = new MatTableDataSource();
  selectedColumn: string = 'mac'; // Default column to filter by
  filterValue: string = '';
  selectedFile: File | null = null;
  currentPage = 1;
  firmwaresSelected: any[] = [];

  private filterSubject = new Subject<[string, number]>();

  constructor(private apiService: ApiService) {}

  ngOnInit() {
    // Listen for changes to filterValue, apply debounce on the API call
    this.filterSubject
      .pipe(
        debounceTime(300), // Debounce time in ms
        switchMap(([filterValue, currentPage]) => {
          let filters: any = {};
          if (filterValue) {
            filters[this.selectedColumn] = filterValue;
          }
          return this.apiService.getFirmwares(currentPage, filters); // API call with filters
        })
      )
      .subscribe((data) => {
        this.dataSource = new MatTableDataSource(data); // Update table data
        this.firmwaresSelected = []; // Reset selected firmwares
      });

    this.filterSubject.next([this.filterValue, this.currentPage]);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tabSelected'] && changes['tabSelected'].currentValue) {
      this.filterSubject.next([this.filterValue, this.currentPage]);
    }
  }

  // Trigger the filter change and emit the new value to filterSubject
  onFilterChange() {
    this.currentPage = 1; // Reset to the first page when filter changes
    this.filterSubject.next([this.filterValue, this.currentPage]);
  }

  // Gestisce la selezione del file
  onFileSelected(event: any): void {
    const file: File = event.target.files[0];
    if (file) {
      this.selectedFile = file;
      console.log('File selezionato:', file.name);
      // Esegui qualsiasi altra logica per gestire il file, come leggere il suo contenuto
    }
  }

  onFileUpload(): void {
    if (!this.selectedFile) {
      return;
    }
    this.loading = true;
    this.apiService.uploadFirmwares(this.selectedFile).subscribe((response) => {
      console.log('Risposta dal server:', response);
      this.loading = false;
      this.selectedFile = null;
    });
  }

  onSelectClick(element: { model: string; version: string }, checked: boolean) {
    const index = this.firmwaresSelected.findIndex(
      (item) => item.model === element.model && item.version === element.version
    );

    if (checked && index === -1) {
      this.firmwaresSelected.push(element);
    } else if (!checked && index !== -1) {
      this.firmwaresSelected.splice(index, 1);
    }
  }

  onSelectAllClick(checked: boolean) {
    if (checked) {
      this.firmwaresSelected = [...this.dataSource.data];
    } else {
      this.firmwaresSelected = [];
    }
  }

  onDeleteClick() {
    const isConfirmed = window.confirm(`Vuoi eliminare i modelli selezionati?`);

    if (!isConfirmed) {
      return;
    }

    this.apiService
      .deleteFirmwares(
        this.firmwaresSelected.map((item) => {
          return { model: item.model, version: item.version };
        })
      )
      .subscribe((response) => {
        console.log('Modelli eliminati:', response);
        this.filterSubject.next([this.filterValue, this.currentPage]);
      });
  }

  onNext() {
    if (this.dataSource.data.length === 0) {
      return;
    }
    this.currentPage++;
    this.filterSubject.next([this.filterValue, this.currentPage]);
  }

  onPrev() {
    if (this.currentPage <= 1) {
      return;
    }
    this.currentPage--;
    this.filterSubject.next([this.filterValue, this.currentPage]);
  }
}
